import React, { useEffect, useState } from "react";
import { CloseOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal } from "antd";
import routers from "../routers";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Recaptcha from "react-recaptcha";
// import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState, Dispatch } from "@/store";
import {
  SET_ACCOUNT,
  SET_PASSWORD,
  SET_RECAPTCHARENDERED,
  SET_RESETPOP,
  SET_VERIFIED,
} from "@/model/login";
import { AuthReply } from "../proto/Auth_pb";
import * as Common from "../proto/Common_pb";
import localforage from "localforage";
import { loginRequestApi } from "../helpers/authApi";
import Routes from "../routers";
import { loginErrorMsg, sendEmailErrorMsg } from "../helpers/errorCodeMsg";
import { RpcError } from "grpc-web";
import ForgotPassword from "@/components/Helpers/ForgotPassword";
import { forgotPasswordApi } from "@/helpers/userApi";

const router_path = Routes.router_path;

function Login() {
  const nav = useNavigate();
  // const { t } = useTranslation();
  const recaptchaRef: any = React.useRef(null);
  //先定義loginState
  const LoginStatus = useSelector((state: RootState) => state.LoginStatus);
  //dispatch 設定好之後就可以引入所有的methods
  const dispatch = useDispatch<Dispatch>();
  const recaptchaRefDiv = React.useRef(null);
  const resetPop = LoginStatus.resetPop;

  React.useEffect(() => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  }, [recaptchaRef]); // 傳入空陣列，只在元件掛載和卸載時執行

  function signUp() {
    nav(routers.router_path.signUp);
  }

  const verifyCallback = (response: any) => {
    if (response) {
      dispatch.LoginStatus.setState({ type: SET_VERIFIED, data: true });
    }
  };

  const recaptchaLoaded = () => {
    // console.log("capcha successfully loaded");
    // dispatch.LoginStatus.setState({ type: SET_RECAPTCHARENDERED, data: true });
  };

  function showForgotPassWord() {
    // setResetPop(true)
    dispatch.LoginStatus.setState({ type: SET_RESETPOP, data: true });
  }

  function onClose() {
    dispatch.LoginStatus.setState({ type: SET_RESETPOP, data: false });
  }

  async function sendEmail(value: any) {
    const result = await forgotPasswordApi(value.email);
    try {
      if (result instanceof Common.CommonReply) {
        localforage.setItem("auth_email", value.email);
        localforage.setItem("router_path", router_path);
        dispatch.LoginStatus.setState({ type: SET_RESETPOP, data: false });
        nav(router_path.resendForgotEmail);
      } else {
        throw new Error();
      }
    } catch (e) {
      const res = result as RpcError;
      Modal.error({
        title: <h3>Error</h3>,
        icon: <CloseCircleOutlined />,
        content: <h6>{sendEmailErrorMsg(res)}</h6>,
        okText: "OK",
        maskClosable: true,
        width: 500,
      });
    }
  }

  async function handleLoginResponse(result: any, email: string) {
    if (result instanceof AuthReply) {
      localforage.setItem("register", { userId: result.toObject().userId });
      if (result.toObject().code === Common.ErrorCodes.USER_EMAIL_INVAILD) {
        return {
          type: "error",
          message: "This account has not been registered successfully",
        };
      } else if (result.toObject().code === Common.ErrorCodes.SUCCESS) {
      
        localforage.setItem<AuthReply.AsObject>(
          "admin_auth",
          result.toObject()
        );
        localforage.setItem("auth_email", email);
        return { type: "success" };
      }
    } else {
      throw new Error();
    }
  }

  async function onFinish({ email }: any) {
    if (true) {
      // recaptchaRef.current.reset();
      const result = await loginRequestApi(
        LoginStatus.loginAccount,
        LoginStatus.loginPassword
      );
      try {
        const response = await handleLoginResponse(result, email);

        if (response!.type === "error") {
          Modal.error({
            title: <h3>Error</h3>,
            icon: <CloseCircleOutlined />,
            content: <h6>{response!.message}</h6>,
            okText: "OK",
            maskClosable: true,
            width: 500,
            onOk() {
              nav(router_path.sendEmail);
            },
          });
        } else if (response!.type === "success") {
          nav(router_path.arProject.index);
        }
      } catch (e) {
        // recaptchaRef.current.reset();
        dispatch.LoginStatus.setState({ type: SET_VERIFIED, data: false });
        const res = result as RpcError;
        Modal.error({
          title: <h3>Error</h3>,
          icon: <CloseCircleOutlined />,
          content: <h6>{loginErrorMsg(res)}</h6>,
          okText: "OK",
          maskClosable: true,
          width: 500,
        });
      }
    } else {
      Modal.error({
        title: <h3>Error</h3>,
        icon: <CloseCircleOutlined />,
        content: <h6>Please verify &quot; I&apos;m not a robot. &quot;</h6>,
        okText: "OK",
        maskClosable: true,
        width: 500,
      });
    }
  }

  return (
    <div className="loginSignUp-screen">
      <div className="loginSignUp-container">
        <div className="logo-container">
          <img
            className="logo-svg"
            src="/images/MetARlogo.svg"
            alt="logo-img"
          />
          {/* <div className="close-icon">
            <CloseOutlined />
          </div> */}
        </div>
        <div className="section">
          <div className="section-left">
            <img
              className="section-img"
              src="/images/A1_01_image.png"
              alt="section-img"
            />
            <h1 className="section-title">
              AR-commerce{" "}
              <span className="section-title-span">Tech Service Platform</span>
            </h1>
          </div>
          <div className="section-right">
            <div className="form">
              <div className="title-group">
                <h1
                  className="form-title"
                  onClick={() => {
                  
                    dispatch.LoginStatus.setState({
                      type: SET_ACCOUNT,
                      data: "james_chen@spe3d.co",
                    });
                    dispatch.LoginStatus.setState({
                      type: SET_PASSWORD,
                      data: '09330932e'
                    })
                  }}
                >
                  Log In
                </h1>
                <p className="form-annotation">
                  Don&apos;t have an account ?{" "}
                  <button className="register-logIn-btn" onClick={signUp}>
                    <span className="register-logIn">Sign Up</span>
                  </button>
                </p>
              </div>
              <Form
                name="login"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    // e.preventDefault();
                  }
                }}
                onFinish={onFinish}
                scrollToFirstError
                autoComplete="off"
              >
                <div className="input-group">
                  <Form.Item
                    name="email"
                    className="email"
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: "Please input your E-mail!",
                      },
                    ]}
                  >
                    <Input
                      bordered={false}
                      onChange={(e) => {
                        dispatch.LoginStatus.setState({
                          type: SET_ACCOUNT,
                          data: e.target.value,
                        });
                        // setLoginAccount(e.target.value)
                      }}
                      value={LoginStatus.loginAccount}
                      className="input"
                      required={true}
                    />
                  </Form.Item>
                  {LoginStatus!.loginAccount ? (
                    <p
                      style={{
                        transform: "translateY(-80%)",
                        fontSize: "0.8rem",
                        transition: "0.2s",
                      }}
                    >
                      Email
                    </p>
                  ) : (
                    <p>Email</p>
                  )}
                </div>
                <div className="input-group">
                  <Form.Item
                    name="password"
                    className="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password
                      bordered={false}
                      value={LoginStatus.loginPassword}
                      onChange={(e) =>
                        dispatch.LoginStatus.setState({
                          type: SET_PASSWORD,
                          data: e.target.value,
                        })
                      }
                      className="input"
                      required={true}
                    />
                  </Form.Item>
                  {LoginStatus!.loginPassword ? (
                    <p
                      style={{
                        transform: "translateY(-80%)",
                        fontSize: "0.8rem",
                        transition: "0.2s",
                      }}
                    >
                      Password
                    </p>
                  ) : (
                    <p>Password</p>
                  )}
                </div>
                <div className="forgot">
                  <span onClick={showForgotPassWord}>Forgot PassWord ?</span>
                </div>
                <div className="recaptcha-item" ref={recaptchaRefDiv}>
                  {/* {shouldRenderRecaptcha && (
                    <Recaptcha
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_PUBLIC_KEY}
                      render="explicit"
                      onloadCallback={recaptchaLoaded}
                      verifyCallback={verifyCallback}
                      id="loginpage"
                    />
                  )} */}
                  {/* <Recaptcha
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_PUBLIC_KEY}
                      render="explicit"
                      onloadCallback={recaptchaLoaded}
                      verifyCallback={verifyCallback}
                      id="loginpage_e"
                    /> */}
                </div>
                {/* <Verify recaptchaRef={recaptchaRef} recaptchaLoaded={recaptchaLoaded} verifyCallback={verifyCallback} /> */}
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Log In
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
        <div className="footer">
          <p>
            *By logging in, you agree to our
            <Link to={routers.router_path.helpCenter}>
              <span> Terms of Use </span>
            </Link>
            and to receive METAR commerce
          </p>
          <p>
            emails & updates and acknowledge that you read our Privacy Policy.
          </p>
        </div>
      </div>
      {resetPop ? (
        <ForgotPassword cancel={onClose} onfinish={sendEmail} />
      ) : null}
    </div>
  );
}

export default Login;
